<template>
  <div class="sales-table">
    <app-table-dropdown
      :isHeaderLink="false"
      route="/sales/item/"
      routeItem="number"
      :response="list || []"
      :isAllClose="isAllClose"
    >
      <template #header>
        <div class="app-table-dropdown__table-header">
          <span class="app-table-dropdown__table-header-title">Статус</span>
          <span
            v-if="!responsive.isMd"
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('date', sort.order, sort.field === 'date')
              )
            "
          >
            Дата
            <div
              v-if="sort.field === 'date'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('number', sort.order, sort.field === 'number')
              )
            "
          >
            Номер
            <div
              v-if="sort.field === 'number'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span
            v-if="!responsive.isMobile"
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('volume', sort.order, sort.field === 'volume')
              )
            "
          >
            Объем
            <div
              v-if="sort.field === 'volume'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span
            v-if="!responsive.isMobile"
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
          >
            Лот
          </span>
          <span
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('amount', sort.order, sort.field === 'amount')
              )
            "
          >
            Сумма
            <div
              v-if="sort.field === 'amount'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
        </div>
      </template>

      <template #row-header="{ item }">
        <div class="app-table-dropdown__row-header-default">
          <div class="app-table-dropdown__row-header-default-item">
            <span
              class="order-status"
              :class="getClassOrderStatus(item.status.code)"
            ></span>
            {{ item.status.text || 'н/д' }}
            <span class="order-status__count" v-if="getUnreadMessages(item)">{{
              getUnreadMessages(item)
            }}</span>
          </div>
          <div
            v-if="!responsive.isMd"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            {{ item.createdAt | dateFormat() }}
          </div>
          <div
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            {{ item.number || 'н/д' }}
          </div>

          <div
            v-if="!responsive.isMobile"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            {{ item.volume.value }} {{ perUnitText(item.volume.unit) }}.
          </div>
          <div
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            <span v-if="item.lotId">№{{ item.lotId }}</span>
            <span v-else>н/д</span>
          </div>
          <div
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            <span>{{ item.priceTotal | price() }} руб.</span>
            <span class="app-table-dropdown__old-price" v-if="item.discount"
              >{{ item.priceTotalWithoutDiscount | price() }} руб.</span
            >
          </div>
        </div>
      </template>

      <template #row-body="{ item }">
        <sales-table-item :response="item"></sales-table-item>
      </template>

      <template #portal="{ item }">
        <sales-table-portal :response="item"></sales-table-portal>
      </template>
    </app-table-dropdown>
  </div>
</template>

<script>
import {
  getClassOrderStatus,
  getDiscountPrice,
  changeSort,
  perUnitText,
} from '@/helpers';

export default {
  name: 'SalesTable',
  inject: ['responsive'],
  components: {
    AppTableDropdown: () => import('@/components/common/AppTableDropdown'),
    SalesTableItem: () =>
      import('@/pages/sales/components/table/SalesTableItem'),
    SalesTablePortal: () =>
      import('@/pages/sales/components/table/SalesTablePortal'),
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    salesListMessages: {
      type: Array,
      required: false,
    },
    isAllClose: {
      type: Boolean,
    },
    sort: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getDiscountPrice,
    perUnitText,
    changeSort,
    getClassOrderStatus,
    getUnreadMessages(item) {
      return this.salesListMessages.find((el) => el.itemNumber === item.number)
        ?.unreadMessagesCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.sales-table {
  // -
}
</style>
